export default "__VITE_ASSET__vW2aHV0u__"